<template>

  <div>

    <rueden-header :title="'Kostenlose Erstberatung'"/>

    <!-- 1. Angaben zum Auto  -->
    <div class="container pt-4 pt-md-5 pb-5" v-if="step === 1">
      <form name="abgas_kostenlose-erstberatung_1" id="form_1" autocomplete="off">

        <schrittanzeige
          :step="step"
          :last="stepCount"
          :title="'Jetzt <b>kostenlos</b> prüfen, ob Sie Anspruch auf Entschädigung im Abgasskandal haben!'"
        />

        <div class="row">
          <div class="col-12 col-lg-8 offset-lg-2">
            <div class="formular-box">
              <div class="row">
                <div class="col-12">
                  <h2 class="mt-0 pt-0 mb-0 pb-4 pb-md-5">1. Allgemeine Angaben</h2>
                </div>
              </div>

              <suggest-input
                key="Automarke"
                v-model="automarke"
                label="Welche Automarke fahren Sie?"
                uri="https://node.wvr-law.de/api/get/all-brands.php"
                :required="true"
              />

              <div class="row">
                <select-input
                  key="RSVbeiKauf"
                  v-model="rsv_bei_kauf_vorhanden"
                  label="Waren Sie zum Zeitpunkt des Autokaufs rechtsschutzversichert?"
                  :list="[
                    {text: 'Ja', value: 'Ja'},
                    {text: 'Nein', value: 'Nein'}
                  ]"
                  :required="true"
                />
              </div>

              <div class="row">
                <select-input
                  key="Finanzierungsart"
                  v-model="finanzierungsart"
                  label="Wie haben Sie das Fahrzeug finanziert?"
                  :list="[
                    {text: 'Barkauf', value: 'Voll bezahlt'},
                    {text: 'Finanzierung', value: 'Darlehen'},
                    {text: 'Leasing', value: 'Leasing'},
                    {text: 'Mietkauf', value: 'Mietkauf'}
                  ]"
                  placeholder="- Bitte auswählen -"
                  :required="true"
                />
              </div>

              <next-back-step
                key="NextBack1"
                v-model="step"
              />

            </div>
          </div>
        </div>

      </form>
    </div>

    <div class="container pt-4 pt-md-5 pb-5" v-if="step === 2">

      <schrittanzeige
        :step="step"
        :last="stepCount"
        :title="'Jetzt <b>kostenlos</b> prüfen, ob Sie Anspruch auf Entschädigung im Abgasskandal haben!'"
      />

      <form name="abgas_kostenlose-erstberatung_2" id="form_2">
        <div class="row">
          <div class="col-12 col-lg-8 offset-lg-2">
            <div class="formular-box">

              <div class="row">
                <div class="col-12">
                  <h2 class="mt-0 pt-0 mb-0 pb-4 pb-md-5">2. Ihre Kontaktdaten</h2>
                </div>
              </div>

              <div class="row">
                <select-input
                  key="Anrede"
                  v-model="anrede"
                  :list="[
                    {text: 'Frau', value: 'Frau'},
                    {text: 'Herr', value: 'Herr'},
                  ]"
                  :required="true"
                />
              </div>

              <div class="row">
                <text-input
                  key="Vorname"
                  v-model="vorname"
                  label="Vorname"
                  :required="true"
                />
                <text-input
                  key="Nachname"
                  v-model="nachname"
                  label="Nachname"
                  :required="true"
                />
              </div>

              <div class="row">
                <text-input
                  key="Email"
                  v-model="email"
                  label="E-Mail"
                  type="email"
                  :required="true"
                />
                <text-input
                  key="Telefon"
                  v-model="telefon"
                  label="Telefon"
                  type="tel"
                  :required="true"
                />
              </div>

              <next-back-step
                key="NextBack2"
                v-model="step"
                :back_button="true"
                submit-button="Erstberatung anfordern"
              />

            </div>
          </div>
        </div>

      </form>

    </div>

    <div class="container pt-4 pt-md-5 pb-5" v-if="step === 3">
      <schrittanzeige
          :step="step"
          :last="stepCount"
          :title="'Jetzt <b>kostenlos</b> prüfen, ob Sie Anspruch auf Entschädigung im Abgasskandal haben!'"
      />
      <abschluss
          :error="error"
      />
    </div>

    <rueden-footer
      :show_datenschutz="step === 2"
      :show_berlin="step === 2" />

  </div>

</template>
<script>
import TextInput from "@/components/all/text-input";
const STEP_COUNT = 3;

import Abgasskandal from '@/mixins/abgasskandal';
import General from '@/mixins/general';

import RuedenHeader from '@/components/all/rueden-header';
import Schrittanzeige from '@/components/all/schrittanzeige';
import SuggestInput from "@/components/all/suggest-input";
import SelectInput from "@/components/all/select-input";
import NextBackStep from "@/components/all/next-back-buttons";

import Abschluss from "@/components/all/abschluss";
import RuedenFooter from "@/components/all/rueden-footer";

export default {

  mixins: [General, Abgasskandal],

  components: {
    RuedenFooter,
    Abschluss,
    TextInput,
    RuedenHeader,
    Schrittanzeige,
    SelectInput,
    SuggestInput,
    NextBackStep,
  },

  data() {
    return {
      stepCount: STEP_COUNT,
      step: 1,
      quelle: 'WvR-Law.de', // Es wird "Homepage" angezeigt
      adresse: {},
      automarke: this.$route.query.automarke,
      rsv_bei_kauf_vorhanden: null,
      finanzierungsart: null,
      anrede: null,
      vorname: null,
      nachname: null,
      email: null,
      telefon: null,
      error: null,
    }
  },
  mounted() {
    document.title = 'Abgasskandal - Kostenlose Erstberatung';
    this.$global.gaCat = 'Lead Funnel Abgas';
  },
  watch: {
    step: function (curStep) {
      if (curStep == this.stepCount) {
        this.error = this.createToDoVorgang(this.$data);
      }
    },
  },
}
</script>
